import { FunctionComponent } from "react";

import {
  Dialog,
  CheckboxField,
  SubmissionForm,
  TextInputField,
  Heading,
  Stack,
  Text
} from "@bps/fluent-ui";
import { useUpdateApplication } from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.hooks";
import {
  ApplicationDto,
  IpRangeDto
} from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.dtos";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Validator } from "@bps/validator";

export interface UpdateApplicationDialogProps {
  application: ApplicationDto;
  tenant: Tenant;
  onDismiss: () => void;
}

export interface UpdateApplicationFormValues {
  name: string;
  isEnabled: boolean;
  ipRanges?: IpRangeDto[];
}

const updateApplicationValidator = new Validator<UpdateApplicationFormValues>(
  validator => ({ name: validator.string().required() })
);

export const UpdateApplicationDialog: FunctionComponent<UpdateApplicationDialogProps> = ({
  application,
  tenant,
  onDismiss
}) => {
  const { mutateAsync: updateApplication } = useUpdateApplication();

  const onSubmit = async (formData: UpdateApplicationFormValues) => {
    await updateApplication({
      name: formData.name,
      applicationId: application.id,
      tenantId: tenant.id,
      ipRanges: formData.ipRanges,
      isEnabled: formData.isEnabled
    });
    onDismiss();
  };

  const defaultValues = {
    name: application.name,
    isEnabled: application.isEnabled,
    ipRanges: application.ipRanges
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        title: "Update Application",
        showCloseButton: true,
        onDismiss
      }}
      minWidth={450}
    >
      <SubmissionForm<UpdateApplicationFormValues>
        onSubmit={onSubmit}
        initialValues={defaultValues}
        validate={updateApplicationValidator.validate}
        hideCancelButton
      >
        {() => {
          return (
            <Stack tokens={{ childrenGap: 8 }}>
              <TextInputField name="name" label="Name" required />
              <CheckboxField label="Allow Gateway Access" name="isEnabled" />
              <Heading labelPaddings>Ip Ranges (Optional)</Heading>
              <Stack tokens={{ childrenGap: 8 }} verticalAlign="space-between">
                <Stack
                  horizontal
                  tokens={{ childrenGap: 8 }}
                  verticalAlign="center"
                >
                  <TextInputField
                    name="ipRanges[0].ipRangeBegin"
                    placeholder="IP Range Begin"
                  />
                  <Text>to</Text>
                  <TextInputField
                    name="ipRanges[0].ipRangeEnd"
                    placeholder="IP Range End"
                  />
                </Stack>
                <Stack
                  horizontal
                  tokens={{ childrenGap: 8 }}
                  verticalAlign="center"
                >
                  <TextInputField
                    name="ipRanges[1].ipRangeBegin"
                    placeholder="IP Range Begin"
                  />
                  <Text>to</Text>
                  <TextInputField
                    name="ipRanges[1].ipRangeEnd"
                    placeholder="IP Range End"
                  />
                </Stack>
              </Stack>
            </Stack>
          );
        }}
      </SubmissionForm>
    </Dialog>
  );
};
